import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = ({ variant = 'page' }) => {
  if (variant === 'auth') {
    return (
      <ContentLoader
        speed={1.8}
        width="100%"
        height={760}
        viewBox="0 0 1200 760"
        backgroundColor="#d9e2ec"
        foregroundColor="#f8fbff"
      >
        <rect x="340" y="72" rx="18" ry="18" width="520" height="34" />
        <rect x="430" y="126" rx="12" ry="12" width="340" height="18" />
        <rect x="390" y="188" rx="28" ry="28" width="420" height="430" />
        <rect x="440" y="232" rx="12" ry="12" width="320" height="20" />
        <rect x="500" y="268" rx="16" ry="16" width="200" height="18" />
        <rect x="440" y="332" rx="14" ry="14" width="320" height="54" />
        <rect x="440" y="420" rx="14" ry="14" width="320" height="54" />
        <rect x="440" y="514" rx="16" ry="16" width="320" height="56" />
      </ContentLoader>
    );
  }

  return (
    <ContentLoader
      speed={1.8}
      width="100%"
      height={760}
      viewBox="0 0 1200 760"
      backgroundColor="#d9e2ec"
      foregroundColor="#f8fbff"
    >
      <rect x="36" y="34" rx="28" ry="28" width="1128" height="122" />
      <rect x="76" y="72" rx="12" ry="12" width="126" height="18" />
      <rect x="76" y="102" rx="18" ry="18" width="238" height="28" />
      <rect x="950" y="70" rx="16" ry="16" width="156" height="54" />

      <rect x="36" y="186" rx="28" ry="28" width="1128" height="520" />
      <rect x="76" y="224" rx="18" ry="18" width="1010" height="2" />
      <rect x="76" y="258" rx="10" ry="10" width="170" height="18" />
      <rect x="846" y="244" rx="16" ry="16" width="260" height="46" />

      <rect x="76" y="316" rx="14" ry="14" width="1010" height="56" />
      <rect x="76" y="392" rx="10" ry="10" width="1010" height="44" />
      <rect x="76" y="448" rx="10" ry="10" width="1010" height="44" />
      <rect x="76" y="504" rx="10" ry="10" width="1010" height="44" />
      <rect x="76" y="560" rx="10" ry="10" width="1010" height="44" />
      <rect x="76" y="616" rx="10" ry="10" width="1010" height="44" />
    </ContentLoader>
  );
};

export default Loader;
